export default __webpack_public_path__ + "9053babfbd3257f75a33156a4dca481c.svg";